type JsEventMessageType = {
  jsEventMessage: JSEventType;
};

type WebkitType = {
  messageHandlers: JsEventMessageType;
};

type JSBridgeType = {
  trackAnalyticsEvent: (event: string) => void;
  openUserProfile: (event: string) => void;
  openDiamondPurchaseScreen: (event: string) => void;
  earningPage: (event: string) => void;
  chatPricePage: (event: string) => void;
  openScreen: (event: string) => void;
};

type JSEventType = {
  postMessage: (event: string) => void;
};

interface CustomWindow {
  JSBridge: JSBridgeType;
  webkit: WebkitType;
}

declare const window: CustomWindow;

// For Android
const JSBridge = typeof window !== "undefined" ? window.JSBridge : undefined;
// For IOS
const JSEventMessage =
  typeof window !== "undefined"
    ? window?.webkit?.messageHandlers?.jsEventMessage
    : undefined;

const TriggerEvent = (eventName: string, data: object = {}) => {
  try {
    if (JSBridge) {
      JSBridge.trackAnalyticsEvent(
        JSON.stringify({ event_name: eventName, event_params: { ...data } })
      );
    }
    if (JSEventMessage) {
      JSEventMessage.postMessage(
        JSON.stringify({ event_name: eventName, event_params: { ...data } })
      );
    }
  } catch (err) {
    console.log(err);
  }
};

const TriggerProfileRedirectEvent = (eventName: string, data: object = {}) => {
  try {
    if (JSBridge) {
      JSBridge.openUserProfile(
        JSON.stringify({ event_name: eventName, event_params: { ...data } })
      );
    }
    if (JSEventMessage) {
      JSEventMessage.postMessage(
        JSON.stringify({ event_name: eventName, event_params: { ...data } })
      );
    }
  } catch (err) {
    console.log(err);
  }
};

const TriggerDiamondPurchaseScreenRedirectEvent = (
  eventName: string,
  data: object = {}
) => {
  try {
    if (JSBridge) {
      JSBridge.openDiamondPurchaseScreen(
        JSON.stringify({ event_name: eventName, event_params: { ...data } })
      );
    }
    if (JSEventMessage) {
      JSEventMessage.postMessage(
        JSON.stringify({ event_name: eventName, event_params: { ...data } })
      );
    }
  } catch (err) {
    console.log(err);
  }
};

const TriggerEarningPageEvent = (eventName: string, data: object = {}) => {
  try {
    if (JSBridge) {
      JSBridge.earningPage(
        JSON.stringify({ event_name: eventName, event_params: { ...data } })
      );
    }
    if (JSEventMessage) {
      JSEventMessage.postMessage(
        JSON.stringify({ event_name: eventName, event_params: { ...data } })
      );
    }
  } catch (err) {
    console.log(err);
  }
};

const TriggerChatPricePageEvent = (eventName: string, data: object = {}) => {
  try {
    if (JSBridge) {
      JSBridge.chatPricePage(
        JSON.stringify({ event_name: eventName, event_params: { ...data } })
      );
    }
    if (JSEventMessage) {
      JSEventMessage.postMessage(
        JSON.stringify({ event_name: eventName, event_params: { ...data } })
      );
    }
  } catch (err) {
    console.log(err);
  }
};

const TriggerCallRedirectEvent = (
  eventName: string,
  eventParams: object = {}
) => {
  try {
    if (JSBridge) {
      JSBridge.openScreen(
        JSON.stringify({ event_name: eventName, event_params: eventParams })
      );
    }
    if (JSEventMessage) {
      JSEventMessage.postMessage(
        JSON.stringify({ event_name: eventName, event_params: eventParams })
      );
    }
  } catch (err) {
    console.log(err);
  }
};

export {
  TriggerEvent,
  TriggerProfileRedirectEvent,
  TriggerDiamondPurchaseScreenRedirectEvent,
  TriggerEarningPageEvent,
  TriggerChatPricePageEvent,
  TriggerCallRedirectEvent,
};
